/**
 * Single registry of tenant feature flags. Keys must match LaunchDarkly and backend OpenFeature
 * flag names exactly (`tg_` prefix, snake_case). Defaults must stay in sync with backend fail-closed
 * values (DT-10350).
 */
export const flagDefaults = {
  // Existing backend flag used for end-to-end verification of this integration.
  tg_ui_test: false,
} as const;

export type TenantFlagKey = keyof typeof flagDefaults;
